<template>
  <EditarBase
    nomeSingular="Inquilino"
    nomePlural="Inquilinos"
    @recurso="handleRecursoEvent($event)"
    @submitSuccess="emitSubmitSuccess"
    @submitError="emitSubmitError"
    @closeModalEdit="closeModalEdit"
  >
    <v-col cols="12">
      <v-row>
        <v-col cols="10">
          <span class="opacity-5 text-dark">
            {{ $t("Tipo_pessoa") }}
          </span>
          <CamposTipoNregistro
            :nRegistro="recurso.nRegistro"
            :tipoCliente="recurso.tipoCliente"
            @nRegistro="recurso.nRegistro = $event"
            @tipo="recurso.tipoCliente = $event"
            :disabled="true"
            class="
              input-style
              font-size-input
              text-light-input
              placeholder-light
              input-icon
            "
            dense
            flat
            filled
            solo
          ></CamposTipoNregistro>
        </v-col>
        <v-col cols="12" md="2">
          <span class="opacity-5 text-dark">
            {{ $t("Status") }}
          </span>
          <v-select
            v-model="recurso.statusComum"
            :items="statusComumItems"
            item-text="text"
            item-value="value"
            label="Status comum"
            single-line
            class="
              input-style
              font-size-input
              text-light-input
              placeholder-light
              input-icon
            "
            dense
            flat
            filled
            solo
          ></v-select>
        </v-col>
        <v-col cols="12">
          <span class="opacity-5 text-dark">
            {{ $t("Fantasia") }}
          </span>
          <v-text-field
            v-model="recurso.fantasia"
            :label="$t('Fantasia')"
            name="fantasia"
            class="
              input-style
              font-size-input
              text-light-input
              placeholder-light
              input-icon
            "
            dense
            flat
            filled
            solo
          >
          </v-text-field>
        </v-col>

        <v-col cols="12">
          <span class="opacity-5 text-dark">
            {{ $t("RazaoSocial") }}
          </span>
          <v-text-field
            v-model="recurso.razaoSocial"
            :label="$t('RazaoSocial')"
            name="razaoSocial"
            class="
              input-style
              font-size-input
              text-light-input
              placeholder-light
              input-icon
            "
            dense
            flat
            filled
            solo
          />
        </v-col>

        <v-col md="9" cols="9" sm="9">
          <span class="opacity-5 text-dark">
            {{ $t("Tipo_contratacao") }}
          </span>
          <v-select
            v-model="recurso.tipoContratacao"
            :items="itensTipoContratacao"
            :label="$t('Tipo_contratacao')"
            item-text="text"
            class="
              input-style
              font-size-input
              text-light-input
              placeholder-light
              input-icon
            "
            dense
            flat
            filled
            solo
          ></v-select>
        </v-col>
        <v-col class="d-flex" cols="3" md="3" sm="3">
          <ModalImagem
            v-if="recurso.id"
            :modalImagem="modalImagem"
            @modalImagem="modalImagem = $event"
            :id="recurso.id"
          >
            <v-btn
              class="
                ma-1
                font-weight-bold
                text-none
                btn-primary
                bg-gradient-primary
                py-3
                px-6
                ms-3
              "
              height="39"
              @click="modalImagem = true"
            >
              <v-icon left dark> mdi-plus-circle </v-icon>
              {{ $t("Enviar_imagem") }}
            </v-btn>
          </ModalImagem>
        </v-col>
        <v-col cols="12">
          <CriaSuperSet
            :podeEditarRecursoFinal="false"
            @recursos="recurso.modulosContratacao = $event"
            :usaRecursoBase="false"
            :payload="recurso.modulosContratacao"
            tituloFinais="Modulos_contratacao"
            subtituloFinais="Clique_para_adicionar"
            :headersFinais="[
              {
                text: this.$t('Tipo'),
                value: 'tipo',
                sortable: 'true',
              },

              { text: this.$t('Acoes'), value: 'actions', sortable: 'false' },
            ]"
            textoBotaoCadastro="Criar_item"
          >
            <template v-slot:default="slotProps">
              <!-- Form cria recurso final -->
              <v-col cols="12" md="12">
                <v-autocomplete
                  :items="modulosDisponiveis"
                  :filter="filtraModulo"
                  :label="$t('Digite_para_pesquisar')"
                  :no-data-text="$t('Nenhum_resultado_encontrado')"
                  :rules="[(v) => !!v || $t('Campo_obrigatorio')]"
                  v-model="slotProps.recursoFinalAtual.tipo"
                  autofocus
                  class="
                    input-style
                    font-size-input
                    text-light-input
                    placeholder-light
                    input-icon
                  "
                  dense
                  flat
                  filled
                  solo
                ></v-autocomplete>
              </v-col>
            </template>
          </CriaSuperSet>
        </v-col>

        <v-col cols="12" md="6">
          <span class="opacity-5 text-dark">
            {{ $t("codigoUnidade") }}
          </span>
          <v-text-field
            v-model="recurso.codigoUnidade"
            :label="$t('codigoUnidade')"
            name="codigoUnidade"
            type="number"
            class="
              input-style
              font-size-input
              text-light-input
              placeholder-light
              input-icon
            "
            dense
            flat
            filled
            solo
          >
          </v-text-field>
        </v-col>

        <v-col cols="12" v-if="recurso.endereco">
          <v-row>
            <v-col cols="12" md="3">
              <span class="opacity-5 text-dark">
                {{ $t("CEP") }}
              </span>
              <BuscaCep
                @cidades="cidades = $event"
                @loading-cidades="cidadeLoading = $event"
                @bairro="recurso.endereco.bairro = $event"
                @cep="recurso.endereco.cep = $event"
                @cidade="recurso.endereco.cidade = $event"
                @logradouro="recurso.endereco.logradouro = $event"
                :cepProp="recurso.endereco.cep || ''"
              ></BuscaCep>
            </v-col>
            <v-col cols="12" md="4">
              <span class="opacity-5 text-dark">
                {{ $t("Cidade") }}
              </span>
              <v-autocomplete
                :label="$t('Cidade')"
                outlined
                v-model="recurso.endereco.cidade"
                :items="cidades"
                :loading="cidadeLoading"
                :disabled="cidadeLoading && cidades.length === 0"
                :no-data-text="
                  cidadeLoading ? $t('Carregando') : $t('SEMREGISTROS')
                "
                return-object
                item-text="nome"
                class="
                  input-style
                  font-size-input
                  text-light-input
                  placeholder-light
                  input-icon
                "
                dense
                flat
                filled
                solo
              >
              </v-autocomplete>
            </v-col>

            <!-- <v-col cols="12" md="6">
                <v-text-field
                  :label="$t('Descricao')"
                  class="purple-input"
                  name="empresa_descricao"
                />
              </v-col> -->

            <v-col cols="12" md="5">
              <span class="opacity-5 text-dark">
                {{ $t("Bairro") }}
              </span>
              <v-text-field
                v-model="recurso.endereco.bairro"
                :label="$t('Bairro')"
                name="bairro"
                class="
                  input-style
                  font-size-input
                  text-light-input
                  placeholder-light
                  input-icon
                "
                dense
                flat
                filled
                solo
              />
            </v-col>

            <v-col cols="12" md="10">
              <span class="opacity-5 text-dark">
                {{ $t("Logradouro") }}
              </span>
              <v-text-field
                v-model="recurso.endereco.logradouro"
                :label="$t('Logradouro')"
                name="logradouro"
                class="
                  input-style
                  font-size-input
                  text-light-input
                  placeholder-light
                  input-icon
                "
                dense
                flat
                filled
                solo
              >
              </v-text-field>
            </v-col>
            <v-col cols="12" md="2">
              <span class="opacity-5 text-dark">
                {{ $t("Numero") }}
              </span>
              <v-text-field
                v-model="recurso.endereco.numero"
                :label="$t('Numero')"
                name="empresa_numero"
                type="number"
                @blur="buscaGeoCode"
                class="
                  input-style
                  font-size-input
                  text-light-input
                  placeholder-light
                  input-icon
                "
                dense
                flat
                filled
                solo
              >
              </v-text-field>
            </v-col>

            <v-col cols="12" md="6">
              <span class="opacity-5 text-dark">
                {{ $t("Complemento") }}
              </span>
              <v-text-field
                v-model="recurso.endereco.complemento"
                :label="$t('Complemento')"
                name="empresa_complemento"
                class="
                  input-style
                  font-size-input
                  text-light-input
                  placeholder-light
                  input-icon
                "
                dense
                flat
                filled
                solo
              />
            </v-col>

            <v-col cols="12" md="3">
              <span class="opacity-5 text-dark">
                {{ $t("Latitude") }}
              </span>
              <v-text-field
                v-model="recurso.endereco.latitude"
                :label="$t('Latitude')"
                name="latitude"
                type="number"
                class="
                  input-style
                  font-size-input
                  text-light-input
                  placeholder-light
                  input-icon
                "
                dense
                flat
                filled
                solo
              />
            </v-col>

            <v-col cols="12" md="3">
              <span class="opacity-5 text-dark">
                {{ $t("Longitude") }}
              </span>
              <v-text-field
                v-model="recurso.endereco.longitude"
                :label="$t('Longitude')"
                name="longitude"
                type="number"
                class="
                  input-style
                  font-size-input
                  text-light-input
                  placeholder-light
                  input-icon
                "
                dense
                flat
                filled
                solo
              />
            </v-col>

            <v-col cols="12" md="3">
              <span class="opacity-5 text-dark">
                {{ $t("nIe") }}
              </span>
              <v-text-field
                v-model="recurso.inscricaoEstadual"
                :label="$t('nIe')"
                name="nIe"
                class="
                  input-style
                  font-size-input
                  text-light-input
                  placeholder-light
                  input-icon
                "
                dense
                flat
                filled
                solo
              />
            </v-col>

            <v-col cols="12" md="3">
              <span class="opacity-5 text-dark">
                {{ $t("nIm") }}
              </span>
              <v-text-field
                v-model="recurso.inscricaoMunicipal"
                :label="$t('nIm')"
                name="nIm"
                class="
                  input-style
                  font-size-input
                  text-light-input
                  placeholder-light
                  input-icon
                "
                dense
                flat
                filled
                solo
              />
            </v-col>
            <v-col cols="12" md="5">
              <span class="opacity-5 text-dark">
                {{ $t("regimeEspecialTributacao") }}
              </span>
              <v-select
                v-model="recurso.regimeEspecialTributacao"
                :items="regimeEspecialTributacaoItems"
                :label="$t('regimeEspecialTributacao')"
                single-line
                class="
                  input-style
                  font-size-input
                  text-light-input
                  placeholder-light
                  input-icon
                "
                dense
                flat
                filled
                solo
              ></v-select>
            </v-col>
            <v-col cols="12" md="5">
              <span class="opacity-5 text-dark">
                {{ $t("regimeEspecialTributacaoNacional") }}
              </span>
              <v-select
                v-model="recurso.regimeEspecialTributacaoNacional"
                :items="regimeEspecialTributacaoNacionalItems"
                :label="$t('regimeEspecialTributacaoNacional')"
                single-line
                class="
                  input-style
                  font-size-input
                  text-light-input
                  placeholder-light
                  input-icon
                "
                dense
                flat
                filled
                solo
              ></v-select>
            </v-col>
            <v-col cols="12" md="4">
              <span class="opacity-5 text-dark">
                {{ $t("simplesNacionalOpcao") }}
              </span>
              <v-select
                v-model="recurso.simplesNacionalOpcao"
                :items="simplesNacionalOpcaoItems"
                :label="$t('simplesNacionalOpcao')"
                single-line
                class="
                  input-style
                  font-size-input
                  text-light-input
                  placeholder-light
                  input-icon
                "
                dense
                flat
                filled
                solo
              ></v-select>
            </v-col>
            <v-col cols="12" md="5">
              <span class="opacity-5 text-dark">
                {{ $t("simplesNacionalRegime") }}
              </span>
              <v-select
                v-model="recurso.simplesNacionalRegime"
                :items="simplesNacionalRegimeItems"
                :label="$t('simplesNacionalRegime')"
                single-line
                class="
                  input-style
                  font-size-input
                  text-light-input
                  placeholder-light
                  input-icon
                "
                dense
                flat
                filled
                solo
              ></v-select>
            </v-col>
            <v-col cols="12" md="3">
              <v-checkbox
                v-model="recurso.nfsePadraoNacional"
                class="font-size-input text-light-input placeholder-light"
                dense
                flat
                filled
                solo
              >
                <template v-slot:label>
                  {{ $t("nfsePadraoNacional") }}
                </template>
              </v-checkbox>
            </v-col>
            <v-col cols="12" md="4">
              <v-checkbox
                v-model="recurso.integracaoPropriaDocumentoFiscal"
                class="font-size-input text-light-input placeholder-light"
                dense
                flat
                filled
                solo
              >
                <template v-slot:label>
                  {{ $t("integracaoPropriaDocumentoFiscal") }}
                </template>
              </v-checkbox>
            </v-col>

            <v-col cols="12" md="4">
              <span class="opacity-5 text-dark">
                {{ $t("ambienteDocumentoFiscal") }}
              </span>
              <v-select
                v-model="recurso.ambienteDocumentoFiscal"
                :items="ambienteDocumentoFiscalItems"
                :item-text="textoOpcaoFiscal"
                item-value="value"
                :label="$t('ambienteDocumentoFiscal')"
                :hint="$t('ambienteDocumentoFiscalAjuda')"
                persistent-hint
                class="
                  input-style
                  font-size-input
                  text-light-input
                  placeholder-light
                  input-icon
                "
                dense
                flat
                filled
                solo
              />
            </v-col>

            <v-col cols="12" md="2">
              <span class="opacity-5 text-dark">
                {{ $t("OrigemEstoque") }}
              </span>
              <v-text-field
                v-model="recurso.origemEstoque"
                :label="$t('OrigemEstoque')"
                name="origemEstoque"
                type="number"
                class="
                  input-style
                  font-size-input
                  text-light-input
                  placeholder-light
                  input-icon
                "
                dense
                flat
                filled
                solo
              />
            </v-col>
            <v-col cols="12" md="2">
              <span class="opacity-5 text-dark">
                {{ $t("matrizFinanceira") }}
              </span>
              <v-text-field
                v-model="recurso.matrizFinanceira"
                :label="$t('matrizFinanceira')"
                name="matrizFinanceira"
                type="number"
                class="
                  input-style
                  font-size-input
                  text-light-input
                  placeholder-light
                  input-icon
                "
                dense
                flat
                filled
                solo
              />
            </v-col>
            <v-col cols="12" md="2">
              <span class="opacity-5 text-dark">
                {{ $t("matrizOperacional") }}
              </span>
              <v-text-field
                v-model="recurso.matrizOperacional"
                :label="$t('matrizOperacional')"
                name="matrizOperacional"
                type="number"
                class="
                  input-style
                  font-size-input
                  text-light-input
                  placeholder-light
                  input-icon
                "
                dense
                flat
                filled
                solo
              />
            </v-col>
            <v-col cols="12" md="3">
              <span class="opacity-5 text-dark">
                {{ $t("matrizOperacionalPonto") }}
              </span>
              <v-text-field
                v-model="recurso.matrizOperacionalPonto"
                :label="$t('matrizOperacionalPonto')"
                name="matrizOperacionalPonto"
                type="number"
                class="
                  input-style
                  font-size-input
                  text-light-input
                  placeholder-light
                  input-icon
                "
                dense
                flat
                filled
                solo
              />
            </v-col>
            <v-col cols="12" md="3">
              <span class="opacity-5 text-dark">
                {{ $t("suporteMatriz") }}
              </span>
              <v-text-field
                v-model="recurso.suporteMatriz"
                :label="$t('suporteMatriz')"
                name="suporteMatriz"
                type="number"
                min="1"
                class="
                  input-style
                  font-size-input
                  text-light-input
                  placeholder-light
                  input-icon
                "
                dense
                flat
                filled
                solo
              />
            </v-col>
            <v-col cols="12" md="3">
              <span class="opacity-5 text-dark">
                {{ $t("suporteBotao") }}
              </span>
              <v-text-field
                v-model.trim="recurso.suporteBotao"
                :label="$t('suporteBotao')"
                name="suporteBotao"
                maxlength="80"
                class="
                  input-style
                  font-size-input
                  text-light-input
                  placeholder-light
                  input-icon
                "
                dense
                flat
                filled
                solo
              />
            </v-col>
            <v-col cols="12" md="3">
              <v-checkbox
                v-model="recurso.suporteIa"
                :label="$t('suporteIa')"
                name="suporteIa"
                dense
              />
            </v-col>
            <v-col cols="12" md="3">
              <span class="opacity-5 text-dark">
                {{ $t("transporteToleranciaMinutosAgrupamentoRoteirizacao") }}
              </span>
              <v-text-field
                v-model="
                  recurso.transporteToleranciaMinutosAgrupamentoRoteirizacao
                "
                :label="
                  $t('transporteToleranciaMinutosAgrupamentoRoteirizacao')
                "
                name="transporteToleranciaMinutosAgrupamentoRoteirizacao"
                type="number"
                class="
                  input-style
                  font-size-input
                  text-light-input
                  placeholder-light
                  input-icon
                "
                dense
                flat
                filled
                solo
              />
            </v-col>
            <v-col cols="12" md="3">
              <span class="opacity-5 text-dark">
                {{ $t("cercaPerimetroToleranciaMetros") }}
              </span>
              <v-text-field
                v-model="recurso.cercaPerimetroToleranciaMetros"
                :label="$t('cercaPerimetroToleranciaMetros')"
                name="cercaPerimetroToleranciaMetros"
                type="number"
                class="
                  input-style
                  font-size-input
                  text-light-input
                  placeholder-light
                  input-icon
                "
                dense
                flat
                filled
                solo
              />
            </v-col>
            <v-col cols="12" md="3">
              <v-checkbox
                v-model="recurso.cercaPerimetroNotificarGestor"
                class="font-size-input text-light-input placeholder-light"
                dense
                flat
                filled
                solo
              >
                <template v-slot:label>
                  {{ $t("cercaPerimetroNotificarGestor") }}
                </template>
              </v-checkbox>
            </v-col>
            <v-col cols="12" md="3">
              <v-checkbox
                v-model="recurso.cercaPerimetroNotificarFuncionario"
                class="font-size-input text-light-input placeholder-light"
                dense
                flat
                filled
                solo
              >
                <template v-slot:label>
                  {{ $t("cercaPerimetroNotificarFuncionario") }}
                </template>
              </v-checkbox>
            </v-col>
            <v-col cols="12" md="6">
              <span class="opacity-5 text-dark">
                {{ $t("Site") }}
              </span>
              <v-text-field
                v-model="recurso.site"
                :label="$t('Site')"
                name="site"
                class="
                  input-style
                  font-size-input
                  text-light-input
                  placeholder-light
                  input-icon
                "
                dense
                flat
                filled
                solo
              />
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-col>
  </EditarBase>
</template>

<script>
import BuscaCep from "@/components/base/proprios/BuscaCep";
import InquilinoDataService from "@/services/software/InquilinoDataService";
const DataService = InquilinoDataService;

import EditarBase from "@/components/base/Crud/EditarBase";
import CamposTipoNregistro from "@/components/base/proprios/CamposTipoNregistro";
import CriaSuperSet from "@/components/base/proprios/CriaSuperset";
import ModalImagem from "@/components/base/proprios/ModalImagem";
import listas from "@/mixins/listas";
import ComumDataService from "@/services/ComumDataService";
import { TIPO_AMBIENTE_EMISSAO_OPTIONS } from "@/utils/fiscalOptions";
import { normalizarBusca } from "@/utils/inquilinoParametrizacoes";
export default {
  name: "CadastroInquilino",
  components: {
    CamposTipoNregistro,
    EditarBase,
    ModalImagem,
    BuscaCep,
    CriaSuperSet,
  },
  mixins: [listas],
  data() {
    return {
      cidades: [],
      cidadeLoading: false,
      submited: false,
      DataService: DataService,
      modalImagem: false,

      recurso: {
        fantasia: "",
        nRegistro: "",
        razaoSocial: "",
        tipoCliente: "",
        tipoContratacao: "",
        modulosContratacao: [],
        nfsePadraoNacional: false,
        integracaoPropriaDocumentoFiscal: false,
        ambienteDocumentoFiscal: "HOMOLOGACAO",
        suporteMatriz: null,
        suporteBotao: "",
        suporteIa: false,
        cercaPerimetroNotificarGestor: false,
        cercaPerimetroNotificarFuncionario: false,
        cercaPerimetroToleranciaMetros: null,
        simplesNacionalOpcao: "",
        simplesNacionalRegime: "",
        regimeEspecialTributacaoNacional: "",
        recurso: {
          endereco: {
            cep: "",
            cidade: {},
            bairro: "",
            logradouro: "",
          },
          fantasia: "",
          razaoSocial: "",
          tipoCliente: "",
          tipoContratacao: "",
          nregistro: "",
          imagem: "string",
          imagem64: "string",
          gestorCep: "",
          gestorCidade: {},
          gestorBairro: "",
          gestorLogradouro: "",
        },
      },

      errors: [],

      itensTipo: [
        { text: this.$t("Pessoa_fisica"), value: "PESSOAFISICA" },
        { text: this.$t("Pessoa_juridica"), value: "PESSOAJURIDICA" },
      ],
      itensTipoContratacao: [
        { text: this.$t("RRP"), value: "RRP" },
        { text: this.$t("ORGAOPUBLICO"), value: "ORGAOPUBLICO" },
        { text: this.$t("GESTAOEFETIVO"), value: "GESTAOEFETIVO" },
        //{ text: this.$t("RRPPLUS"), value: "RRPPLUS" },
        // { text: this.$t("GESTAOEFETIVOPLUS"), value: "GESTAOEFETIVOPLUS" },
      ],

      statusComumItems: [
        { text: this.$t("Ativo"), value: "ATIVO" },
        { text: this.$t("Inativo"), value: "INATIVO" },
      ],
      regimeEspecialTributacaoItems: [
        {
          text: this.$t("MICROEMPRESAMUNICIPAL"),
          value: "MICROEMPRESAMUNICIPAL",
        },
        { text: this.$t("ESTIMATIVA"), value: "ESTIMATIVA" },
        {
          text: this.$t("SOCIEDADEPROFISSIONAIS"),
          value: "SOCIEDADEPROFISSIONAIS",
        },
        { text: this.$t("COOPERATIVA"), value: "COOPERATIVA" },
        { text: this.$t("MEISIMPLES"), value: "MEISIMPLES" },
        { text: this.$t("MESIMPLES"), value: "MESIMPLES" },
      ],
      regimeEspecialTributacaoNacionalItems: [
        { text: this.$t("NENHUM"), value: "NENHUM" },
        { text: this.$t("COOPERATIVA"), value: "COOPERATIVA" },
        { text: this.$t("ESTIMATIVA"), value: "ESTIMATIVA" },
        { text: this.$t("MICROMUNICIPAL"), value: "MICROMUNICIPAL" },
        { text: this.$t("NOTARIOREGISTRADOR"), value: "NOTARIOREGISTRADOR" },
        { text: this.$t("AUTONOMO"), value: "AUTONOMO" },
        {
          text: this.$t("SOCIEDADEPROFISSIONAIS"),
          value: "SOCIEDADEPROFISSIONAIS",
        },
      ],
      simplesNacionalOpcaoItems: [
        { text: this.$t("NAOOPTANTE"), value: "NAOOPTANTE" },
        { text: this.$t("OPTANTEMEI"), value: "OPTANTEMEI" },
        { text: this.$t("OPTANTEMEEPP"), value: "OPTANTEMEEPP" },
      ],
      simplesNacionalRegimeItems: [
        { text: this.$t("APURACAOSN"), value: "APURACAOSN" },
        {
          text: this.$t("APURACAOFEDERAISSNEISSQNMUNICIPAL"),
          value: "APURACAOFEDERAISSNEISSQNMUNICIPAL",
        },
        {
          text: this.$t("APURACAOFEDERALEMUNICIPALTRIBUTO"),
          value: "APURACAOFEDERALEMUNICIPALTRIBUTO",
        },
      ],
      ambienteDocumentoFiscalItems: TIPO_AMBIENTE_EMISSAO_OPTIONS,
    };
  },
  computed: {
    // Módulos ainda não contratados, em ordem alfabética, para o form de inclusão
    modulosDisponiveis() {
      const contratados = (this.recurso.modulosContratacao || []).map(
        (modulo) => modulo.tipo
      );
      return this.modulosContratacaoInquilino
        .filter((modulo) => !contratados.includes(modulo.value))
        .sort((a, b) => a.text.localeCompare(b.text));
    },
  },
  methods: {
    // Busca pelo nome traduzido ou pelo código, ignorando acentos
    filtraModulo(item, queryText) {
      const busca = normalizarBusca(queryText);
      return (
        normalizarBusca(item.text).includes(busca) ||
        normalizarBusca(item.value).includes(busca)
      );
    },
    handleRecursoEvent(event) {
      this.recurso = {
        ...event,
        suporteIa: event.suporteIa === true,
        cercaPerimetroNotificarGestor:
          event.cercaPerimetroNotificarGestor === true,
        cercaPerimetroNotificarFuncionario:
          event.cercaPerimetroNotificarFuncionario === true,
        ambienteDocumentoFiscal: event.ambienteDocumentoFiscal || "HOMOLOGACAO",
      };
    },
    textoOpcaoFiscal(item) {
      return this.$t(item.textKey);
    },
    emitSubmitSuccess(recursoAtualizado = this.recurso) {
      this.$emit("submitSuccess", recursoAtualizado);
    },
    emitSubmitError() {
      this.$emit("submitError");
    },
    closeModalEdit() {
      this.$emit("closeModalEdit");
    },
    buscaGeoCode() {
      if (this.recurso.endereco.numero.length >= 1) {
        ComumDataService.buscaGeoCode(
          this.enderecoParaString(this.recurso.endereco)
        ).then((response) => {
          if (response.data.results[0]) {
            this.recurso.endereco.latitude =
              response.data.results[0].geometry.location.lat;
            this.recurso.endereco.longitude =
              response.data.results[0].geometry.location.lng;
          }
        });
      }
    },
    enderecoParaString(endereco) {
      var string = "";

      if (endereco.logradouro) string = endereco.logradouro;

      if (endereco.numero) string = string + ", " + endereco.numero;

      if (endereco.bairro) string = string + ", " + endereco.bairro;

      return string;
    },
  },
};
</script>

<style scoped></style>
